import { useEffect, useState, useContext } from "react";
import { UserContext } from "../UserContext";
import { useNavigate } from "react-router-dom";

const useTokenVerification = () => {
  const [linkVerified, setLinkVerified] = useState(false);
  const [loading, setLoading] = useState(true);
  const [tokenPresent, setTokenPresent] = useState(true); // New state to track if token is present
  const navigate = useNavigate();
  const { setUserId } = useContext(UserContext);


  useEffect(() => {
    const validateToken = async () => {
      const searchParams = new URLSearchParams(window.location.search);
      const token = searchParams.get("token");

      if (token === null) {
        // Token parameter is not present
        setTokenPresent(false);
        setLoading(false);
        return;
      } else if (token === "") {
        // Token parameter is present but empty
        setLinkVerified(false);
        setLoading(false);
        return;
      }

      try {
        const response = await fetch('/mdpr/v1/registration/api/v1/ping/validate-token', {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ token }),
        });

        const data = await response.json();

        if (!response.ok) {
          navigate("/public/registrationContactSupport", { state: { errorType: "technical" } });
        } else {
          if (data && data.status === "Success") {
            setUserId(data.userId);
            setLinkVerified(true);
          } else {
            navigate("/public/registrationContactSupport", { state: { errorType: "registration" } });
          }
        }
      } catch (error) {
        navigate("/public/registrationContactSupport", { state: { errorType: "technical" } });
      } finally {
        setLoading(false);
      }
    };

    validateToken();
  }, [setUserId, navigate]);

  return { linkVerified, loading, tokenPresent }; // Return tokenPresent state
};

export default useTokenVerification;